import { Container, Paper, Typography } from '@mui/material';
import { OrganizationProfile } from '@clerk/react';


const OrganizationManagementPage = () => (
  <Container maxWidth="lg" sx={{ pt: 14, pb: 6 }}>
    <Paper sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>Company users</Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        Invite, replace, or remove members of your active company organization.
      </Typography>
      <OrganizationProfile routing="hash">
        <OrganizationProfile.Page label="members" />
      </OrganizationProfile>
    </Paper>
  </Container>
);

export default OrganizationManagementPage;
